module.exports = __webpack_public_path__ + "img/49.832ee40a.jpg";